import { Fragment } from "react";
import { respondTo } from "@utilities/styled-components";
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import Banner from "./Banner/Banner";
import WebLinks from "./Header/WebLinks";
import BestOffer from "./Promotion/BestOffer";
import ProductOnSale from "./ProductOnSale/ProductOnSale";
import MostPopular from "./Promotion/MostPopular";
import DisclaimerText from "./Header/DisclaimerText";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import AddItemToCart from "@pages/Cart/ShoppingCart/AddItemToCart";
import { useSelector, useDispatch } from "react-redux";
import { getSharedWebLinks } from "@slices/webSettings";
import { useGetLoggedInUserInfo } from "@hooks";
import {webSettingsSelector} from "@slices/webSettings";

interface Props {}

function HomePage(props: Props) {
  const sessionId = useGetLoggedInUserInfo();
  const webSettingsData: any = useContext(WebSettingsContext);
  const {} = props;
  const [showAddToCart, setShowAddToCart] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
   dispatch(getSharedWebLinks(sessionId?.sessionId))
  }, []);

  const webLinks = useSelector(webSettingsSelector);

  return (
    <div style={{ minHeight: "79vh" }}>
      <DisclaimerText />
      <AddItemToCart
        status={showAddToCart}
        onClose={setShowAddToCart}
      ></AddItemToCart>
      <section>
        <div className="promotional-area">
          <Banner />
        </div>
      </section>
      {webSettingsData?.showPromotionalItems ? (
        <div className="row best-offer-wraper">
          <div className="col-lg-12">
            <div className="best-offer-position">
              <BestOffer />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row">
        <div className="col-lg-12">
          <ProductOnSale onAddToCartActon={setShowAddToCart} />
        </div>
      </div>
      {webSettingsData?.showMostPopularItems ? (
        <div className="row">
          <div className="col-lg-12 most-popu-position">
            <MostPopular />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row">
          <div className="col-lg-12 web-link-position">
            <WebLinks webLinks={webLinks?.webLinks?.homePageWebLinks}/>
          </div>
      </div>
      
       
    </div>
  );
}

export default HomePage;
